import { BACKEND_URL } from "@/lib/api";

// Local (own storage) images are served in variants: thumb 360px, card 960px, large 1920px.
export const imgSrc = (url, size = "large") => {
  if (!url) return url;
  const i = url.indexOf("/api/images/");
  if (i === -1) return url;
  const base = `${BACKEND_URL}${url.slice(i).split("?")[0]}`;
  return size && size !== "large" ? `${base}?size=${size}` : base;
};

export const relImg = (url) => {
  const i = (url || "").indexOf("/api/images/");
  return i === -1 ? url : url.slice(i).split("?")[0];
};

export const usePrefersReducedMotion = () =>
  typeof window !== "undefined" && window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
